class INTENT.widgets.ResizableCreative

  @ATTR_NAME: "data-widget-resizable-creative"

  @SIZE_FIELD: "#creative-size"
  @RESIZABLE: "#resizable"
  @RESIZABLE_FIELDS: "#dynamic_size"

  constructor: (@el) ->
    @s = @.constructor

    $(@s.RESIZABLE).on 'change', =>
      @handleResizable()

  handleResizable: () =>
    checked = $("#{@s.RESIZABLE}:checked").length
    resizable_fields = $(@s.RESIZABLE_FIELDS)
    size_field = $(@s.SIZE_FIELD)

    if(checked)
      resizable_fields.find('input').attr('disabled', false)
      resizable_fields.slideDown()
      size_field.attr('disabled', true)
    else
      resizable_fields.slideUp () ->
        resizable_fields.find('input').attr('disabled', true)
      size_field.attr('disabled', false)